export default __webpack_public_path__ + "static/media/failed-icon.5572c3e7.svg";